"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PerformerItem = exports.sanitizeThumbnailUrlForStatsD = void 0;
/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
var React = __importStar(require("react"));
var Skeleton_1 = __importDefault(require("@atg/icf-react-components/components/Skeleton"));
var react_1 = require("react");
var react_jss_1 = __importDefault(require("react-jss"));
var Contexts_1 = require("../Contexts");
var Hoverable_1 = require("../utilities/Hoverable");
var Ioc_1 = require("../utilities/Ioc");
var PreloadImage_1 = require("../utilities/PreloadImage");
var FillContentWrapper_1 = require("./FillContentWrapper");
var LiveStatusIndicator_1 = require("./LiveStatusIndicator");
var PerformerItemOverlay_1 = require("./PerformerItemOverlay");
var PerformerStreamPreviewContainer_1 = require("./PerformerStreamPreviewContainer");
var Wrapper = (0, react_jss_1.default)({
    wrapper: {
        alignItems: "center",
        backgroundColor: "#111111",
        boxSizing: "border-box",
        height: "100%",
        justifyContent: "center",
        overflow: "hidden",
        position: "relative",
        transform: "rotate(0.0001deg)", // FYI: This forces the browser to use hardware acceleration.
        width: "100%",
    },
})(function (_a) {
    var classes = _a.classes, props = __rest(_a, ["classes"]);
    return React.createElement("div", __assign({ className: classes.wrapper }, props));
});
var ThumbnailImage = (0, react_jss_1.default)({
    "@keyframes fadeIn": {
        from: { opacity: 0 },
        to: { opacity: 1 },
    },
    thumbnailImage: function (_a) {
        var isBlurred = _a.isBlurred, fadeIn = _a.fadeIn, isHovering = _a.isHovering;
        return (__assign(__assign(__assign(__assign({ backgroundPosition: "center", backgroundSize: "cover" }, (isBlurred && { filter: "blur(16px)" })), { height: "100%", animationDuration: "200ms" }), (fadeIn && { animationName: "$fadeIn" })), { top: 0, transformOrigin: "center", transform: isHovering ? "scale(1.1)" : "scale(1)", transitionDuration: "200ms", transitionProperty: "transform", width: "100%" }));
    },
})((0, react_1.forwardRef)(function (_a, ref) {
    var classes = _a.classes, isBlurred = _a.isBlurred, fadeIn = _a.fadeIn, isHovering = _a.isHovering, alt = _a.alt, isTextBlurEnabled = _a.isTextBlurEnabled, props = __rest(_a, ["classes", "isBlurred", "fadeIn", "isHovering", "alt", "isTextBlurEnabled"]);
    return (
    // eslint-disable-next-line jsx-a11y/alt-text
    React.createElement("img", __assign({ className: classes.thumbnailImage, ref: ref, alt: isTextBlurEnabled ? "" : alt }, props)));
}));
var StreamPreviewWrapper = (0, react_jss_1.default)({
    streamPreviewWrapper: {
        height: "100%",
        position: "absolute",
        top: 0,
        width: "100%",
    },
})(function (_a) {
    var classes = _a.classes, props = __rest(_a, ["classes"]);
    return React.createElement("div", __assign({ className: classes.streamPreviewWrapper }, props));
});
var ContestRankIndicator = (0, react_jss_1.default)(function (theme) { return ({
    contestRankIndicator: {
        background: theme.colors.primary,
        color: theme.colors.textOnDark,
        fontSize: "20px",
        fontWeight: "bold",
        height: "auto",
        // eslint-disable-next-line @atg/css-rtl-support
        left: 0,
        lineHeight: "32px",
        padding: "0 16px",
        position: "absolute",
        top: 0,
        width: "auto",
    },
}); })(function (_a) {
    var classes = _a.classes, props = __rest(_a, ["classes"]);
    return React.createElement("div", __assign({ className: classes.contestRankIndicator }, props));
});
var PerformerAnonymousWrapper = (0, react_jss_1.default)({
    performerAnonymousWrapper: {
        background: "linear-gradient(to bottom, #424242, #2e2e2e)",
        display: "flex",
        height: "100%",
        width: "100%",
    },
})(function (_a) {
    var classes = _a.classes, props = __rest(_a, ["classes"]);
    return React.createElement("div", __assign({ className: classes.performerAnonymousWrapper }, props));
});
var LogoOverlay = (0, react_jss_1.default)(function (theme) { return ({
    logoOverlay: {
        display: "flex",
        position: "absolute",
        top: theme.spacing.base / 2,
        insetInlineStart: theme.spacing.base / 2,
        height: theme.spacing.base * 4,
        width: theme.spacing.base * 4,
    },
    // eslint-disable-next-line jsx-a11y/alt-text
}); })(function (_a) {
    var classes = _a.classes, props = __rest(_a, ["classes"]);
    return React.createElement("img", __assign({ className: classes.logoOverlay }, props));
});
var PerformerAnonymousMessage = (0, react_jss_1.default)(function (theme) { return ({
    performerAnonymousMessage: {
        color: theme.colors.baseContrast050,
        textAlign: "center",
        margin: "auto",
    },
}); })(function (_a) {
    var classes = _a.classes, props = __rest(_a, ["classes"]);
    return React.createElement("span", __assign({ className: classes.performerAnonymousMessage }, props));
});
var isGoldInProgress = function (knownPerformer) {
    return knownPerformer.liveState.goldShow && !knownPerformer.liveState.preGoldShow;
};
// TODO: This is an abuse vector and risks very high cardinality.
var sanitizeThumbnailUrlForStatsD = function (url) {
    // trim out https
    // get the first 2 parts (cdn domain and path)
    // convert . -> _ for statsD reasons
    return url === null || url === void 0 ? void 0 : url.replace("https://", "").split("/").slice(0, 2).join("_slash_").replace(/\./g, "_dot_");
};
exports.sanitizeThumbnailUrlForStatsD = sanitizeThumbnailUrlForStatsD;
var PerformerItem = /** @class */ (function (_super) {
    __extends(PerformerItem, _super);
    function PerformerItem(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this._isMounted = false;
        _this._onFavoriteItemClicked = function () {
            // TODO: Is checked before being used as a prop
            _this.props.onFavoriteIconClicked(_this.props.performerData);
        };
        _this._onNotifyClicked = function (e) {
            /* istanbul ignore next -- TODO: Can't tell how this isn't covered */
            e.stopPropagation();
            /* istanbul ignore next -- TODO: Can't tell how this isn't covered */
            e.preventDefault();
            // TODO: Is checked before being used as a prop?
            /* istanbul ignore next -- TODO: Can't tell how this isn't covered */
            _this.props.onNotifyClicked(_this.props.performerData);
        };
        _this._onClick = function (event) {
            var performerLinkTo = _this._getPerformerLinkTo();
            if (performerLinkTo === "#") {
                event === null || event === void 0 ? void 0 : event.preventDefault();
            }
            if (_this.props.onClick) {
                _this.props.onClick(_this.props.performerData);
            }
        };
        _this._onImageLoad = function () {
            /* istanbul ignore next -- TODO: Need to address how this happens at all, otherwise it can't be simulated */
            if (!_this.state.isImageLoaded) {
                _this.setState({ isImageLoaded: true });
            }
        };
        _this.state = {
            previewLoading: false,
            isHovering: false,
            isImageLoaded: false,
        };
        return _this;
    }
    PerformerItem.prototype.componentDidMount = function () {
        this._isMounted = true;
    };
    PerformerItem.prototype.componentWillUnmount = function () {
        this._isMounted = false;
    };
    PerformerItem.prototype._getBiopicImageSrc = function (nickname, requiresAV) {
        return "".concat(this.props.imageBucket.biopicUrl).concat(requiresAV ? "/s" : "", "/avatar/").concat(nickname, ".webp");
    };
    PerformerItem.prototype._getSnapshotImageSrc = function (performerId) {
        return "".concat(this.props.imageBucket.snapshotUrl, "/320x240/").concat(performerId, ".jpg");
    };
    PerformerItem.prototype._getThumbnailImageSrc = function (knownPerformer, requiresAV) {
        if (requiresAV) {
            return this._getBiopicImageSrc(knownPerformer.nickname, true);
        }
        return !this.props.disableSnapshots && knownPerformer.online
            ? this._getSnapshotImageSrc(knownPerformer.id)
            : this._getBiopicImageSrc(knownPerformer.nickname, false);
    };
    PerformerItem.prototype._getPerformerLinkTo = function () {
        var _a, _b;
        return (_b = (_a = this.props).getPerformerLinkTo) === null || _b === void 0 ? void 0 : _b.call(_a, this.props.performerData);
    };
    PerformerItem.prototype._requiresAgeVerification = function () {
        var _a, _b;
        var userData = this.props.userData;
        return ((_b = (((_a = userData === null || userData === void 0 ? void 0 : userData.ageVerificationRules) === null || _a === void 0 ? void 0 : _a.requiresAgeConfirmation) &&
            (!(userData === null || userData === void 0 ? void 0 : userData.isAuthenticated) || (userData === null || userData === void 0 ? void 0 : userData.isFreemium)))) !== null && _b !== void 0 ? _b : true);
    };
    PerformerItem.prototype.reportFailedThumbnail = function (src) {
        var _a;
        (_a = this.props.statsdClient) === null || _a === void 0 ? void 0 : _a.count("thumbnailFailure." + (0, exports.sanitizeThumbnailUrlForStatsD)(src));
    };
    PerformerItem.prototype.stopRollover = function () {
        var _a, _b;
        if (this._isMounted) {
            this.setState({ isHovering: false });
        }
        (_b = (_a = this.props).onIsHoveringChanged) === null || _b === void 0 ? void 0 : _b.call(_a, false);
    };
    PerformerItem.prototype.getPerformerId = function () {
        var _a;
        // TODO: unsure when performerData should ever by falsy, but there's a test for it.
        if ((_a = this.props.performerData) === null || _a === void 0 ? void 0 : _a.hasDetails) {
            return this.props.performerData.id;
        }
        return null;
    };
    PerformerItem.prototype.displayInlineThumbnails = function (isHoveringAndEnabled, isBlurred, mainImageRef, performerData, mainSrc, fallbackSrc, isTextBlurEnabled) {
        var _this = this;
        var elements = [];
        // TODO: More appropriate skeleton component.
        // TODO: Need isImageLoaded to be true synchronously to prevent gross pop-in.
        if (!this.state.isImageLoaded) {
            elements.push(React.createElement(Skeleton_1.default, { isLoading: !this.state.isImageLoaded, types: ["circle", "line", "line", "line"], hasBackground: false, animation: "pulse" }));
        }
        /* istanbul ignore next */
        elements.push(React.createElement(ThumbnailImage, { alt: performerData.nickname, src: mainSrc, ref: mainImageRef, onError: function () {
                // TODO: Probably never happens given display.
                if (!mainImageRef.current) {
                    return;
                }
                _this.reportFailedThumbnail(mainImageRef.current.src);
                mainImageRef.current.src = fallbackSrc;
            }, isBlurred: isBlurred, isTextBlurEnabled: isTextBlurEnabled, isHovering: isHoveringAndEnabled, onLoad: this._onImageLoad }));
        return elements;
    };
    PerformerItem.prototype.render = function () {
        var _this = this;
        var _a;
        var _b = this.props, emitTrackingEvent = _b.emitTrackingEvent, isLogoVerified = _b.isLogoVerified, isMobile = _b.isMobile, isPreviewEnabled = _b.isPreviewEnabled, isThumbnailBlurred = _b.isThumbnailBlurred, isSoundEnabled = _b.isSoundEnabled, onFavoriteIconClicked = _b.onFavoriteIconClicked, onIsHoveringChanged = _b.onIsHoveringChanged, onNotifyClicked = _b.onNotifyClicked, performerData = _b.performerData, statsdClient = _b.statsdClient, userData = _b.userData;
        var mainImageRef = React.createRef();
        var isTextBlurEnabled = (_a = userData === null || userData === void 0 ? void 0 : userData.ageVerificationRules) === null || _a === void 0 ? void 0 : _a.isTextBlurEnabled;
        var requiresAV = this._requiresAgeVerification();
        return (React.createElement(Wrapper, { "data-ta-locator": "performer_item_" + isMobile ? "mobile" : "desktop" },
            React.createElement(Ioc_1.ContextConsumer, { contexts: [Contexts_1.ILinkComponentContext, Contexts_1.ITranslationServiceContext] }, function (Link, translationService) {
                var LinkComponent = (performerData === null || performerData === void 0 ? void 0 : performerData.hasDetails) ? (React.createElement(Link, { "data-ta-locator": "performer_item_link", to: _this._getPerformerLinkTo(), onClick: _this._onClick },
                    React.createElement(FillContentWrapper_1.FillContentWrapper, null,
                        React.createElement(Hoverable_1.Hoverable, { isEnabled: true, onIsHoveringChanged: onIsHoveringChanged, isHoveringFromParent: _this.state.isHovering, setIsHoveringFromParent: function (isHovering) {
                                _this.setState({ isHovering: isHovering });
                                if (isHovering) {
                                    _this.props.swapRollovers(_this);
                                }
                            } }, function (isHovering) {
                            var _a, _b, _c;
                            var isHoveringAndEnabled = isHovering && isPreviewEnabled;
                            var showStreamPreview = performerData.online &&
                                !isGoldInProgress(performerData) &&
                                !performerData.liveState.onBreak &&
                                !performerData.liveState.privateChat &&
                                !performerData.liveState.exclusiveShow &&
                                isHovering;
                            var previewComponent = showStreamPreview && (React.createElement(StreamPreviewWrapper, { "data-ta-locator": "stream_preview_wrapper_".concat(performerData.id) },
                                React.createElement(PerformerStreamPreviewContainer_1.PerformerStreamPreviewContainer, { userData: _this.props.userData, performerData: performerData, isSoundEnabled: isSoundEnabled && isPreviewEnabled, emitTrackingEvent: emitTrackingEvent, statsdClient: statsdClient, isMobile: _this.props.isMobile, onLoading: function () {
                                        return _this.setState({
                                            previewLoading: true,
                                        });
                                    }, onPlaying: function () {
                                        return _this.setState({
                                            previewLoading: false,
                                        });
                                    }, onError: function () {
                                        _this.setState({
                                            previewLoading: false,
                                        });
                                        if (_this.props.onPreviewError) {
                                            _this.props.onPreviewError();
                                        }
                                    } }, function (_a) {
                                    var isPlaying = _a.isPlaying;
                                    return isPlaying && React.createElement(LiveStatusIndicator_1.LiveStatusIndicator, null);
                                })));
                            var mainSrc = _this._getThumbnailImageSrc(performerData, requiresAV);
                            var fallbackSrc = _this._getBiopicImageSrc(performerData.nickname, requiresAV);
                            var logoSrc = (_b = (_a = _this.props.skinConfig) === null || _a === void 0 ? void 0 : _a.skin_theme) === null || _b === void 0 ? void 0 : _b.favicon_path;
                            return (React.createElement(FillContentWrapper_1.FillContentWrapper, { "data-ta-locator": "performer_item", className: "performer_action_".concat(performerData.id) },
                                !isPreviewEnabled && !isMobile && previewComponent,
                                performerData.inlineThumbnail ? (React.createElement(React.Fragment, { key: "inline_thumbnail_wrapper_".concat(performerData.id) }, _this.displayInlineThumbnails(isHoveringAndEnabled !== null && isHoveringAndEnabled !== void 0 ? isHoveringAndEnabled : false, 
                                // TODO: Better to do this by default to prevent accidental non-compliance?
                                isThumbnailBlurred || false, mainImageRef, performerData, mainSrc, fallbackSrc, isTextBlurEnabled))) : (React.createElement(PreloadImage_1.BackgroundPreloadImage, { key: performerData.id, src: mainSrc, fallbackSrcs: [fallbackSrc] }, function (isLoaded, ref) { return (React.createElement(React.Fragment, null,
                                    !_this.state.isImageLoaded && (React.createElement(Skeleton_1.default, { isLoading: !_this.state.isImageLoaded, types: ["circle", "line", "line", "line"], hasBackground: false, animation: "pulse" })),
                                    isLoaded ? (React.createElement(ThumbnailImage, { alt: performerData.nickname, fadeIn: true, ref: ref, isBlurred: isThumbnailBlurred, isTextBlurEnabled: isTextBlurEnabled, isHovering: isHoveringAndEnabled, onError: function () {
                                            /* istanbul ignore next -- TODO: coverage */
                                            _this.reportFailedThumbnail(fallbackSrc);
                                        }, onLoad: _this._onImageLoad })) : null)); })),
                                performerData.hasDetails && performerData.useLogoOverlay && isLogoVerified && (React.createElement(LogoOverlay, { "data-ta-locator": "studio_logo_overlay", src: logoSrc })),
                                ((_c = performerData.contestState) === null || _c === void 0 ? void 0 : _c.currentContestRank) && (React.createElement(ContestRankIndicator, null, performerData.contestState.currentContestRank)),
                                isPreviewEnabled && previewComponent,
                                React.createElement(PerformerItemOverlay_1.PerformerItemOverlay, { performerData: performerData, isHovering: !!isHoveringAndEnabled, previewLoading: _this.state.previewLoading, showHeadline: _this.props.showHeadlines, onFavoriteIconClicked: onFavoriteIconClicked ? _this._onFavoriteItemClicked : undefined, onNotifyClicked: onNotifyClicked ? _this._onNotifyClicked : undefined })));
                        })))) : null;
                return (performerData &&
                    (performerData.hasDetails ? (React.createElement("div", null,
                        React.createElement(FillContentWrapper_1.FillContentWrapper, null, LinkComponent))) : (React.createElement(PerformerAnonymousWrapper, { "data-ta-locator": "anonymous_performer_item", onClick: function () { var _a, _b; return (_b = (_a = _this.props).onClick) === null || _b === void 0 ? void 0 : _b.call(_a, _this.props.performerData); } },
                        performerData && performerData.contestState && performerData.contestState.currentContestRank && (React.createElement(ContestRankIndicator, null, performerData.contestState.currentContestRank)),
                        React.createElement(PerformerAnonymousMessage, null, translationService.translate("search.performer_anonymous"))))));
            })));
    };
    PerformerItem.defaultProps = {
        isPreviewEnabled: true,
        isThumbnailBlurred: false,
    };
    return PerformerItem;
}(React.Component));
exports.PerformerItem = PerformerItem;
//# sourceMappingURL=PerformerItem.js.map